import axios from "axios";
const API_URL = import.meta.env.VITE_API_URL;

const TrafficFlowPointService  = {
    vehicleTypes: async () => axios.get(API_URL + "/traffic_flow_point/getTrafficFlowVehicleTypes").then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
};

export default TrafficFlowPointService;